import Swiper, { Navigation, Autoplay, Pagination, EffectFade } from "swiper";
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
import 'swiper/swiper-bundle.css';

const slider = () => {
  function initSliderMap() {
    const point = document.getElementById('map-point');
    let mapSlider = document.querySelectorAll('.swiper-map.swiper');
    if (mapSlider.length > 0) {
      mapSlider.forEach((element) => {
        new Swiper(element, {
          slidesPerView: '1',
          speed: 2000,
          effect: 'fade',
          loop: true,
          autoplay: {
            delay: 2000,
          },
        });

        element.swiper.on('slideChange', function () {
          let activeSlide = element.swiper.slides[element.swiper.activeIndex];
          let left = activeSlide.dataset.left + '%';
          let top = activeSlide.dataset.top + '%';
          point.style.left = left;
          point.style.top = top;
        });
      });
    }
  }

  function initSliderHero() {
    let heroSlider = document.querySelectorAll('.hero__slider.swiper');
    if (heroSlider.length > 0) {
      heroSlider.forEach((element) => {
        const parent = element.parentElement;
        const toggle = parent.querySelector('.hero__mute-toggle');
        parent.addEventListener('click', (e)=>{
          e.stopPropagation();
          const active = element.querySelector('.swiper-slide-active video');
          if (active) {
            if (active.muted) {
              active.muted = false;
              toggle.classList.add('unmuted');
            } else {
              active.muted = true;
              toggle.classList.remove('unmuted');
            }
          }
        });
        toggle.addEventListener('click', (e)=>{
          e.stopPropagation();
          const active = element.querySelector('.swiper-slide-active video');
          if (active) {
            if (active.muted) {
              active.muted = false;
              toggle.classList.add('unmuted');
            } else {
              active.muted = true;
              toggle.classList.remove('unmuted');
            }
          }
        });

        new Swiper(element, {
          slidesPerView: '1',
          speed: 3000,
          effect: 'fade',
          loop: true,
          autoplay: {
            delay: 3000,
          },

          on: {
            init: (slider) => {
              slider.autoplay.stop();
            },
            slideChange: (slider) => {
              slider.autoplay.stop();
              const video = slider.slides[slider.activeIndex].querySelector('video');
              if (video) {
                toggle.classList.remove('hidden');
                video.currentTime = 0;
                video.play();

                video.addEventListener('ended', () => {
                  toggle.classList.remove('unmuted');
                  video.pause();
                  video.muted = true;
                  slider.params.autoplay.delay = 300;
                  slider.autoplay.start();
                });
              }
              else {
                toggle.classList.add('hidden');
                slider.params.autoplay.delay = 3000;
                slider.autoplay.start();
              }
            },
          },
        });
      });
    }
  }

  function initSliderPresentation() {
    let presentationSlider = document.querySelectorAll('.swiper-presentation.swiper');
    if (presentationSlider.length > 0) {
      presentationSlider.forEach((element) => {
        new Swiper(element, {
          slidesPerView: '1',
          speed: 1000,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
            clickable: true,
          },
          autoplay: {
            delay: 5000,
          },
        });
      });
    }
  }

  return {
    init() {
      initSliderMap();
      // sliderOnResize();
      initSliderHero();
      initSliderPresentation();
    },
  }
}

export {
  slider,
}
